module.exports = __webpack_public_path__ + "media/images/systems-c5edcbfda548ed8dd6cc20fba480697e.png";